import React, { memo } from 'react';
import classNames from 'classnames';

import Button from '../../helpers/Button';
import FieldError from '../../helpers/FieldError';
import useRequiredFieldErrors from '../../../hooks/useRequiredFieldErrors';

import style from './style.module.css';

const AuthFormComponent = ({ caption, errorContent, isFetching, onSubmit }) => {
  const { errors, formProps } = useRequiredFieldErrors();

  return (
    <form className={style.host} onSubmit={onSubmit} {...formProps}>
      <h1 className={style.title}>Sign in</h1>
      <div className={classNames('form-group', { 'has-error': errors.username })}>
        <label className="field-label" htmlFor="inputUsername">
          Username
        </label>
        <input className="form-control" id="inputUsername" name="username" type="text" required />
        <FieldError message={errors.username} />
      </div>
      <div className={classNames('form-group', { 'has-error': errors.password })}>
        <label className="field-label" htmlFor="inputPassword">
          Password
        </label>
        <input className="form-control" id="inputPassword" name="password" type="password" required />
        <FieldError message={errors.password} />
      </div>
      {errorContent}
      <Button className={classNames(style.submit, 'btn-primary btn-block')} loading={isFetching} type="submit">
        Sign in
      </Button>
      {caption}
    </form>
  );
};

export const AuthForm = memo(AuthFormComponent);
